export const formatWorkspaceRequest = (data: any): any => {
  return {
    ...data,
    description: data.description || "",
    status: data.status || "active"
  };
};
